import styled from "styled-components";
import {INote, Person, StyledBaseProps} from "@betrue/shared/interfaces";
import * as React from "react";
import {useEffect, useRef, useState} from "react";
import {NoteFormProps} from "./note-form";
import {Button, Grid, Icon, TextField} from "@material-ui/core";
import {BtAvatar, Note} from "@betrue/ui";
import moment from "moment";
import SendIcon from "@material-ui/icons/Send";

interface NoteViewProps extends StyledBaseProps, NoteFormProps {
  current: Person,
  notes: INote[],
  onSubmitContent: (v: string) => void
}

export const NoteFormView = styled((props: NoteViewProps) => {
  const [content, setContent] = useState('')

  const messagesEndRef = useRef(null)
  const [notesByDay, setNotesByDay] = useState<Map<string, INote[]>>()

  const scrollToBottom = () => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollTop = messagesEndRef.current.scrollHeight;
    }
  }

  useEffect(() => {
    if (props.notes?.length) {
      setNotesByDay(props.notes.reduce((acc, note: INote, i) => {
        return acc.set(`${moment(note.updatedAt).locale('fr').format("DD MMMM yyyy")}`,
          acc.get(`${moment(note.updatedAt).locale('fr').format("DD MMMM yyyy")}`) ? [
            ...acc.get(`${moment(note.updatedAt).locale('fr').format("DD MMMM yyyy")}`), note] : [note]
        )
      }, new Map<string, INote[]>()))

    }
  }, [props.notes])

  useEffect(() => {
    scrollToBottom()
  })

  return (
    <div className={props.className}>
      <div className={'notes'} ref={messagesEndRef}>
        {notesByDay ? Array.from(notesByDay.keys()).map((v, k) => (<span key={k}>
          <div className={'hr-container'}>
            <div className={'hr-border'}/>
            <span className={'hr-content'}><i>{v}</i></span>
            <div className={'hr-border'}/>
          </div>
          {notesByDay.get(v).map((note) => (<div key={note.id}><Note note={note}/></div>))}
          </span>)) : ''}
      </div>
      <form onSubmit={(e) => {
        e.preventDefault()
        props.onSubmitContent(content)
        setContent('')
      }}>
        <Grid container direction={'row'} spacing={2} alignItems={'center'} alignContent={'center'}>
          <Grid item xs={12}>
            <Grid container direction={'row'} spacing={2} alignItems={'flex-start'} alignContent={'center'}>
              <Grid item xs={2} sm={1}>
                <BtAvatar person={props.current}/>
              </Grid>
              <Grid item className={'capital'} xs={10} sm={11}>
                <TextField
                  multiline
                  variant="outlined"
                  rows={7}
                  InputProps={{
                    style: {alignItems: 'flex-end'},
                    endAdornment: <Button type={"submit"} variant="outlined" color="primary"
                                          startIcon={<SendIcon/>}/>
                  }}
                  value={content}
                  onChange={(e) => setContent(e.target.value)}
                  fullWidth/>

              </Grid>

            </Grid>
          </Grid>

        </Grid>
      </form>
    </div>)
})`
  & {
    .hr-container {
      align-items: center;
      display: flex;
      flex-wrap: nowrap;

      .hr-border {
        border-bottom: 1px solid lightgray;
        width: 100%;
      }
      .hr-content {
        white-space: nowrap;
        flex-wrap: nowrap;
        padding-top: ${props => props.theme.spacing(0.5)};
        padding-bottom: ${props => props.theme.spacing(0.5)};
        padding-right: ${props => props.theme.spacing(2)};
        padding-left: ${props => props.theme.spacing(2)};
        font-size: 12px;
        color: lightgray;
      }
    }

    .notes {
      margin-bottom: 40px;
      max-height: 400px;
      overflow-y: scroll;
      overflow-x: hidden;
    }

    .submit-col {
      button {
        align-items: stretch;
        display: flex;
      }
    }
  }
`
